/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PauseFineTuningJobRequest = {
  fineTuningJobId: string;
};

/** @internal */
export const PauseFineTuningJobRequest$inboundSchema: z.ZodType<
  PauseFineTuningJobRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  fine_tuning_job_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "fine_tuning_job_id": "fineTuningJobId",
  });
});
/** @internal */
export type PauseFineTuningJobRequest$Outbound = {
  fine_tuning_job_id: string;
};

/** @internal */
export const PauseFineTuningJobRequest$outboundSchema: z.ZodType<
  PauseFineTuningJobRequest$Outbound,
  z.ZodTypeDef,
  PauseFineTuningJobRequest
> = z.object({
  fineTuningJobId: z.string(),
}).transform((v) => {
  return remap$(v, {
    fineTuningJobId: "fine_tuning_job_id",
  });
});

export function pauseFineTuningJobRequestToJSON(
  pauseFineTuningJobRequest: PauseFineTuningJobRequest,
): string {
  return JSON.stringify(
    PauseFineTuningJobRequest$outboundSchema.parse(pauseFineTuningJobRequest),
  );
}
export function pauseFineTuningJobRequestFromJSON(
  jsonString: string,
): SafeParseResult<PauseFineTuningJobRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PauseFineTuningJobRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PauseFineTuningJobRequest' from JSON`,
  );
}
